// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  Modal,
  Button,
  Warning
} from '../'


export class DeleteModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    onCancelClick: PropTypes.func.isRequired,
    onConfirmClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    title: 'Delete withdrawal?'
  }

  render() {
    const { title, onCancelClick, onConfirmClick } = this.props

    return (
      <Modal
        heading={title}
        body={
          <div className='slds-text-align_center'>
            <Warning inline={true}>
              Are you sure you want to delete this withdrawal batch?
              <br />
              <span className='slds-text-color_weak slds-text-body_small'>
                (you won't be able to undo this decision)
              </span>
            </Warning>
          </div>
        }
        footer={
          <div className='slds-text-align_center'>
            <Button minWidth={80} onClick={onCancelClick}>
              No
            </Button>
            <Button
              type='brand'
              minWidth={80}
              onClick={onConfirmClick}>
              Yes
            </Button>
          </div>
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-batch-detail/DeleteModal.js